import { Component, OnInit } from '@angular/core';
import { Tab } from 'src/app/model/call/call.model';
import { SavSuivi } from 'src/app/model/suiviCall/suiviCall';

@Component({
  selector: 'app-calls',
  templateUrl: './calls.component.html',
  styleUrls: ['./calls.component.scss']
})
export class CallsComponent implements OnInit {

  tabs :Tab[] = []

  index: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  addTab(newtab : Tab){
    this.tabs.push(newtab);
    // open this new tab, we use length because there's always at least one tab (calls-list)
    this.index = this.tabs.length;
  }

  closeTab(i : number){
    this.tabs.splice(i,1);
    this.index = i;
  }

  changeTab(newtab : Tab, i : number){
    this.tabs.splice(i,1,newtab)
  }

}
